// @packages
import axios from 'axios';

// @scripts
import { config } from '../config';
import { format } from '../helpers';
import { store } from '../core';

// @constants
export const ADD_ITEM_TO_SCHEDULE = 'ADD_ITEM_TO_SCHEDULE';
export const IMPORT_SCHEDULE_ITEMS = 'IMPORT_SCHEDULE_ITEMS';
export const UPDATE_ITEM_FROM_SCHEDULE = 'UPDATE_ITEM_FROM_SCHEDULE';
export const ADD_ITEM_TO_SCHEDULE_IMPORT = 'ADD_ITEM_TO_SCHEDULE_IMPORT';

/**
 * @param {object} item
 */
export const addItemToSchedule = (item) => ({
    type: ADD_ITEM_TO_SCHEDULE,
    payload: item
});

/**
 * @param {object} item
 */
 export const addItemToScheduleImport = (item) => ({
    type: ADD_ITEM_TO_SCHEDULE_IMPORT,
    payload: item
});

/**
 * @param {object} item
 */
export const updateItemFromSchedule = (item, rowIndex) => ({
    type: UPDATE_ITEM_FROM_SCHEDULE,
    payload: { item, rowIndex }
});

/**
 * @param {object[]} scheduleItems
 */
/* istanbul ignore next */
export const sendScheduleItemsToEdge = (scheduleItems) => {
    const { sid } = store.getState().user;
    return axios
        .post(format(config.services.schedule.import, sid), { items: scheduleItems })
        .then(() => {
            if (window.fanSizer) {
                window.location.assign(`${window.louverSelection.settings.paths.root}/edge?sid=${sid}`);
            }
        })
        .catch((error) => Promise.reject(error));
};
